function initSmallLayoutAnimations(){
    //Standard to top link animation
    $('.top-link').on('click',function () {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
    })
}